import FieldConfig from "../../../../fields3/proto/field-config";
import {ConditionType_ArrayIntersection} from "../../../../model2/conditions/condition-types";
import FieldMultiselect from "../../../generic/multiselect/multiselect";
import FieldTaskTypes_AutomationConditionForm from "./render/automations/condition-form";
import FieldTaskTypes_AutomationTriggerForm from "./render/automations/trigger-form";


export default class FieldTaskTypes extends FieldMultiselect {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Task Types";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = false //_.get(config,'addNoValueOption',true);

        // Label for no value option
        // this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Please select');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');


        this.options            = _.get(config, "options", gd.session.taskTypes.exportToOptions())


        this.isSearchable = true;

        this.pillMaxWidth   = 100

        this.conditionTypes         = [ConditionType_ArrayIntersection]


        this.renderComponents.automationConditionForm       = FieldTaskTypes_AutomationConditionForm
        this.renderComponents.automationTriggerForm         = FieldTaskTypes_AutomationTriggerForm
        this.components.PopoverMenuMore                     = null

        this.classes.PopoverContent                         = 'w-250'
    }

    getCsvValue(model:any) {
        const options : any = this._getOptions(model[this.fieldId])
        return _.isEmpty(options) ? '' : _.map(options, option=>option.label).join(', ');
    }

    // getOptions() {
    //
    //     if (!this._options) {
    //         this._options = gd.session.taskTypes.exportToOptions()
    //     }
    //
    //     return this._options
    // }

}




//
// export default class FieldTaskTypes extends FieldMultiselectDynamic {
//
//     constructor(config:FieldConfig) {
//         super(config);
//
//         this.typeLabel = "Task Types";
//
//         // if true will add no value option to options list (by default true for custom fields)
//         this.noValueOption      = _.get(config,'addNoValueOption',true);
//
//         // Label for no value option
//         this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Please select');
//
//         // default placeholder for FORM element
//         this.placeholder        = _.get(config,'placeholder','Please select');
//
//         // this.icon = 'i5-crm-contact';
//
//         this.isSearchable = true;
//
//         this.pillMaxWidth   = 100
//
//         this.conditionTypes         = [ConditionType_ArrayIntersection]
//
//         _.assign(this.components, {
//             // PopoverMenuMore : FieldCRMContact_PopoverMore,
//             // ValueIcon       : <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
//         })
//
//         this.components.PopoverMenuMore     = null
//
//     }
//
//     getCsvValue(model:any) {
//         const options : any = this._getOptions(model[this.fieldId])
//         return _.isEmpty(options) ? '' : _.map(options, option=>option.label).join(', ');
//     }
//
//     getOptions() {
//
//         if (!this._options) {
//             this._options = gd.session.taskTypes.exportToOptions()
//         }
//
//         return this._options
//     }
//
// }
